'use client';

import Link from 'next/link';
import React from 'react';

export default function NotFound() {
  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <h1 style={styles.error}>404</h1>
        <p style={styles.message}>Ooops!!! The page you are looking for is not found</p>
        <Link href="/" style={styles.button}>
          Back to home
        </Link>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '70vh',
    margin: 0,
    padding: 0,
    backgroundColor: '#E7FFFF',
    fontFamily: 'sans-serif',
  },
  container: {
    textAlign: 'center',
  },
  error: {
    fontSize: '120px',
    margin: 0,
    color: '#008B62',
    textShadow:
      '1px 1px 1px #00593E, 2px 2px 1px #00593E, 3px 3px 1px #00593E, 4px 4px 1px #00593E, 5px 5px 1px #00593E, 6px 6px 1px #00593E, 7px 7px 1px #00593E, 8px 8px 1px #00593E, 25px 25px 8px rgba(0,0,0, 0.2)',
  },
  message: {
    fontSize: '18px',
    fontWeight: 500,
    color: '#333',
    margin: '1.5rem 0',
  },
  button: {
    display: 'inline-block',
    padding: '0.75rem 1.25rem',
    backgroundColor: '#222',
    color: '#fff',
    border: '2px solid #222',
    borderRadius: '6px',
    textDecoration: 'none',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    transition: 'all 0.2s ease-in-out',
  },
};
